import './public';

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider as TanStackQueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import App from './components/App';
import { tanstackQueryClient } from './commons/tanstackQueryClient';
import { SelfAttendanceProvider } from './contexts/SelfAttendanceContext';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element with id "root" was not found.');
}

const root = createRoot(rootElement);

root.render(
  <SelfAttendanceProvider>
    <TanStackQueryClientProvider client={tanstackQueryClient}>
      <StrictMode>
        <App />
        {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
      </StrictMode>
    </TanStackQueryClientProvider>
  </SelfAttendanceProvider>
);
